<template>
  <div class="order-claim">
    <div class="claim-section">
      <el-input
        v-model.trim="claimOrderId"
        placeholder="请输入订单号"
        size="small"
        style="width: 300px; margin-right: 10px"
      ></el-input>
      <el-button size="small" type="primary" @click="handleClaim"
        >订单认领</el-button
      >
      <!-- <el-button
        type="text"
        @click="showRecords"
        style="margin-left: 10px; padding: 6px"
        >认领记录</el-button
      > -->
    </div>

    <!-- 订单认领提示弹窗 -->
    <el-dialog
      title="提交成功"
      :visible.sync="claimDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="claim-tip">
        <i class="el-icon-info"></i>
        <p>跟踪订单需要一定时间。</p>
        <p>若订单处于[跟单中]状态，请耐心等待不超过20分钟。</p>
        <p>若20分钟后未成功，需退单后重拍。</p>
      </div>
      <div class="dont-show">
        <el-checkbox v-model="dontShowAgain">不再提示</el-checkbox>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="showRecords">认领记录</el-button> -->
        <el-button @click="handleClaimConfirm" type="primary">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 订单认领记录弹窗 -->
    <!-- <el-dialog
      title="订单认领记录"
      :visible.sync="recordsDialogVisible"
      width="1000px"
    >
      <div style="margin-bottom: 20px">
        <i class="el-icon-info" style="color: #409eff"></i>
        <span
          style="
            margin-left: 5px;
            background: #8a8a8a;
            color: #fff;
            padding: 2px 5px;
          "
          >>跟踪订单需要一定时间。若订单处于[跟单中]状态，请耐心等待不超过20分钟。若20分钟后未成功，需退单后重拍。</span
        >
      </div>
      <el-table
        :data="claimRecords"
        v-loading="recordsLoading"
        max-height="400"
      >
        <div slot="empty">
          <el-empty description="暂无认领记录"></el-empty>
        </div>
        <el-table-column prop="order_id" label="订单号"></el-table-column>
        <el-table-column prop="claim_time" label="认领时间"></el-table-column>
        <el-table-column prop="claim_status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.claim_status)">
              {{ getStatusText(scope.row.claim_status) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0"
        style="margin-top: 20px; text-align: right"
        :current-page="recordsPage"
        :page-size="recordsPageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="fetchRecords"
      ></el-pagination>
    </el-dialog> -->
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "OrderClaim",
  data() {
    return {
      claimOrderId: "",
      claimDialogVisible: false,
      dontShowAgain: false,
      recordsDialogVisible: false,
      claimRecords: [],
      recordsLoading: false,
      recordsPage: 1,
      recordsPageSize: 10,
      total: 0,
    };
  },
  mounted() {},
  methods: {
    handleClaim() {
      if (!this.claimOrderId) {
        this.$message.warning("请输入订单号");
        return;
      }

      // TODO: 调用后端API认领订单
      api
        .post("/api/order-claims", { order_no: this.claimOrderId })
        .then((res) => {
          if (res.data.code === 0) {
            this.claimOrderId = "";
            // 检查是否需要显示弹窗
            const hideClaimTip = localStorage.getItem("hideClaimTip");
            if (!hideClaimTip) {
              this.claimDialogVisible = true;
            } else {
              this.$message.success("订单认领成功");
            }
          } else {
            this.$message.error(res.data.message || "认领失败");
          }
        })
        .catch((e) => {
          this.$message.error(e.userMessage || "认领失败");
        });
    },
    handleClaimConfirm() {
      if (this.dontShowAgain) {
        localStorage.setItem("hideClaimTip", "true");
      }
      this.claimDialogVisible = false;
      this.$emit("confirm")
    },
    goToOrders() {
      if (this.dontShowAgain) {
        localStorage.setItem("hideClaimTip", "true");
      }
      this.claimDialogVisible = false;
      this.$router.push("/orders");
    },
    async showRecords() {
      this.claimDialogVisible = false;
      this.recordsDialogVisible = true;
      this.recordsLoading = true;
      try {
        const res = await api.get("/api/order-claims", {
          params: { page: this.recordsPage, page_size: this.recordsPageSize },
        });
        this.claimRecords = res.data.items || [];
        this.total = res.data.total;
        this.recordsPage = res.data.page;
      } catch (e) {
        this.$message.error(e.userMessage || "获取认领记录失败");
      } finally {
        this.recordsLoading = false;
      }
    },
    fetchRecords(page) {
      this.recordsPage = page;
      this.showRecords();
    },
    getStatusType(status) {
      const statusMap = {
        1: "warning",
        2: "success",
        3: "danger",
      };
      return statusMap[status] || "info";
    },
    getStatusText(status) {
      const textMap = {
        1: "认领中",
        2: "认领成功",
        3: "认领失败",
      };
      return textMap[status] || status || "未知";
    },
  },
};
</script>

<style scoped>
.order-claim {
  font-weight: 400;
}

.claim-tip {
  text-align: center;
  padding: 20px 0;
}

.claim-tip i {
  font-size: 32px;
  color: #409eff;
  margin-bottom: 10px;
  display: block;
}

.claim-tip p {
  font-size: 16px;
  color: #606266;
  margin: 0;
  line-height: 32px;
}

.dont-show {
  text-align: center;
  margin-top: 10px;
}
</style>
